module.exports = "<div class=\"done\">\r\n\t<img src=\"/assets/images/thing_gif.gif\">\r\n\t<h3>Thing created succesfully!</h3>\r\n  <span>You will be redirecting to thing list shortly...</span>\r\n  <!--<span>click <a routerLink=\"/things\">here</a> to view things list</span>-->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/things/onboard/done.component.html
// module id = 1469
// module chunks = 0